// extracted by mini-css-extract-plugin
export default {"container":"importUsersNotifications_container__dWnIW","companyName":"importUsersNotifications_companyName__mhaeY"};